
import { i18nText } from '@/locales';

import {Component, Prop, Vue} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import ClientGeneralFormComponent from "@/UI/components/forms/clientGeneral/ClientGeneralForm.vue";
import {IClientsListItem} from "@/entity/clients/clients.types";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import Badge from "@/UI/components/common/Badge.vue";
import {RouterNameEnum} from "@/router/router.types";
import {FormMix} from "@/UI/mixins/FormMix";
import {Button, Col, FormModel, Input, Row, Select, DatePicker} from "ant-design-vue";
import {ClientGeneralFormData} from "@/form/Clients/General/client";
import {FormLayoutMix} from "@/UI/mixins/Layouts/Form";
import {ClientsCategoryMix} from "@/UI/mixins/Clients/ClientCategoryMix";
import {SourcesMix} from "@/UI/mixins/SourcesMix";
import {ClientsStore} from "@/store/modules/Clients";
import {clientDataMix} from "@/UI/components/clients/mixins/clientDataMix";
import EDateTimePicker from "@/UI/components/EDateTimePicker/EDateTimePicker.vue";
import {ProxyTableData} from "../Helpers/ProxyTableData";
import {DisplayMasks} from "@/UI/mixins/DisplayMasks";
import moment from "moment";

@Component({
  components: {
    ClientGeneralFormComponent,
    Badge,
    PageTitle,
    BaseDataForm,
    "a-col": Col,
    "a-row": Row,
    "a-button": Button,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-date-picker": DatePicker,
    "a-input": Input,
    "a-textarea": Input.TextArea,
    "e-datetimepicker": EDateTimePicker
  },
})
export default class ClientGeneral extends mixins(
    FormMix,
    FormLayoutMix,
    ClientsCategoryMix,
    SourcesMix,
    clientDataMix,
    ProxyTableData,
    DisplayMasks
) {
  @Prop() readonly client!: IClientsListItem;
  calls: Array<IClientsListItem> = [];
  get clientData(): IClientsListItem { return this.client; }

  async onSubmit(): Promise<void> {
    (this.$refs.clientData as FormModel).validate(async (valid) => {
      if (!valid) return;
      try {
        const response = await ClientsStore.update(this.clientFormData);
        if (!response.status) { this.$message.error(response.response); return; }
        this.$message.success(response.response);
        await this.$router.push({name: RouterNameEnum.Clients, params: {Studio: String(this.clientFormData.salon_id)}});
      } catch (error) {
        this.$message.error(error.response?.data?.message || error.message);
      }
    });
  }

  setFormData(clientForm: ClientGeneralFormData, clientData: any): void {
    clientForm["id"] = Number(Vue.router.currentRoute.params["id"]);
    clientForm["name"] = clientData["name"];
    clientForm["email"] = clientData["email"];
    clientForm["salon_id"] = clientData["salon_id"];
    clientForm["phone"] = clientData["phone"];
    clientForm["sex"] = clientData["sex"];

    if(clientData["birthday_date"]) {
        clientForm["birthday_date"] = moment(clientData["birthday_date"], 'DD.MM.YYYY') as any;
    }
    clientForm["comment"] = clientData["comment"];
    clientForm["sold"] = clientData["sold"];
    clientForm["paid"] = clientData["paid"];
    clientForm["category"] = clientData["category"] || [];
    clientForm["source"] = clientData["source"] || [];
  }

  async created(): Promise<void> {
    this.formReady = false
    try {
      await this.fetchModule([
        {s: 'category', p: {limit: -1, filter: {salon_id: this.client.salon_id}}},
        {s: 'sources', p: this.client.salon_id},
      ])
      this.setFormData(this.clientFormData, this.clientData);
      console.log(this.clientData)
    } catch (e) {
      console.error(e);
    } finally {
      this.formReady = true;
    }
  }
}
